<div class="data-tracking-container" *ngIf="dataEditSummary != null && isDataReceived">
  <div class="headers">
    <span matTooltip="{{dataEditSummary.title}}">{{dataEditSummary.title}}</span>
  </div>
  <mat-accordion class="data-tracking-mat-accordion" multi="true">
    <mat-expansion-panel  [expanded] = "true" *ngFor="let summariesByType of dataEditSummary.summariesByType">
      <mat-expansion-panel-header [collapsedHeight]="'50'" [expandedHeight]="'50'">
        <mat-panel-title>
          <span [class]="'icon-container ' + summariesByType.categoryIconClass"></span>
          {{summariesByType.categoryTitle}} &nbsp;<span class="count">({{summariesByType.dataTransportSummaries.length}})</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-expansion-panel  [expanded] = "true" *ngFor="let dataTransportSummary of summariesByType.dataTransportSummaries">
        <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
          <mat-panel-title>
            <span matTooltip="{{dataTransportSummary.title}}">{{dataTransportSummary.title}}</span> <i *ngIf="summariesByType.categoryType !== 'DirectEdit'" class="fa-regular fa-arrow-up-right-from-square" (click)="onOpenSource($event, dataTransportSummary)"></i>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
          <li *ngFor="let dataEditFieldSummaryResponse of dataTransportSummary.dataEditFieldSummaryResponses">
            <particle-dynamic-tooltip-container
              [openOption]="'hover'"
              [htmlElement]="dataEditFieldSummaryResponse.toolTip"
              [theme]="'dark'">
              <span class="text"> {{dataEditFieldSummaryResponse.title}} </span> &nbsp;
              <span class="count">({{dataEditFieldSummaryResponse.numberOfRecordsEdited}})</span> &nbsp;
            </particle-dynamic-tooltip-container>
          </li>
        </ul>
      </mat-expansion-panel>
    </mat-expansion-panel>
  </mat-accordion>
</div>
<div *ngIf="!dataEditSummary && isDataReceived" class="lable-empty-data">There are no data sources available</div>
<div *ngIf="!isDataReceived" class="lable-loading-data">Loading data sources..</div>
